module.exports = __webpack_public_path__ + "img/User-avatar.svg.8a325975.png";